import ActionType from './action-type'
import * as Actions from './actions'
import {TimeRange} from '../../../values/TimeRange'
import {type WasTrendScore} from '../../../values/was-trend-score/WasTrendScore'

export function requestTrendAction(timeRange: TimeRange): Actions.RequestTrendAction {
    return {
        type: ActionType.REQUEST_TREND,
        payload: timeRange,
    }
}

/**
 * CDS-6008. Clears the loading flag for one range without touching its trend,
 * so a failed fetch stops the graph spinning and leaves whatever was last
 * received on screen.
 */
export function trendRequestFailedAction(timeRange: TimeRange): Actions.TrendRequestFailedAction {
    return {
        type: ActionType.TREND_REQUEST_FAILED,
        payload: timeRange,
    }
}

export function receiveTrendAction(
    timeRange: TimeRange,
    scores: WasTrendScore[],
): Actions.ReceiveTrendAction {
    return {
        type: ActionType.RECEIVE_TREND,
        payload: {
            timeRange: timeRange,
            scores: scores,
        },
    }
}
